import { render, staticRenderFns } from "./TagManageDialog.vue?vue&type=template&id=c1325b2e&scoped=true"
import script from "./TagManageDialog.vue?vue&type=script&lang=js"
export * from "./TagManageDialog.vue?vue&type=script&lang=js"
import style0 from "./TagManageDialog.vue?vue&type=style&index=0&id=c1325b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1325b2e",
  null
  
)

export default component.exports